(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["medusa-custom-build"] && !Shopify.designMode) return;
  try {
    
function initMedusaBuild(root){
  if(root.dataset.ready)return;
  root.dataset.ready='true';
  root.addEventListener('click',function(event){
    const trigger=event.target.closest('[data-select]');
    if(!trigger||!root.contains(trigger))return;
    const key=trigger.dataset.select;
    root.querySelectorAll('[data-select]').forEach(function(button){button.setAttribute('aria-expanded',String(button.dataset.select===key));});
    root.querySelectorAll('[data-card]').forEach(function(card){card.hidden=card.dataset.card!==key;});
  });
}
document.querySelectorAll('[data-custom-build]').forEach(initMedusaBuild);
document.addEventListener('shopify:section:load',function(event){event.target.querySelectorAll('[data-custom-build]').forEach(initMedusaBuild);});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["medusa-discovery"]) return;
  try {
    
if (!customElements.get('medusa-discovery')) customElements.define('medusa-discovery', class extends HTMLElement {
  connectedCallback() {
    if(this.ready)return;this.ready=true;
    this.searchDialog=this.querySelector('.md-search-dialog');this.input=this.querySelector('#md-query');this.results=this.querySelector('.md-results');this.status=this.querySelector('.md-status');this.all=this.querySelector('.md-all');this.collectionLinks=this.querySelector('.md-collection-links');this.related=this.querySelector('.md-related');this.ideas=this.querySelector('.md-ideas');this.clear=this.querySelector('.md-clear');
    this.onClick=e=>{const open=e.target.closest('[data-md-search-open]');const query=e.target.closest('[data-md-query]');if(!open&&!query)return;e.preventDefault();if(!this.searchDialog.open){this.opener=open;this.searchDialog.showModal();}this.input.focus();if(query){clearTimeout(this.timer);this.input.value=query.dataset.mdQuery;this.search();}};
    document.addEventListener('click',this.onClick);
    this.querySelector('.md-close').addEventListener('click',()=>this.searchDialog.close());
    this.searchDialog.addEventListener('close',()=>{if(this.opener?.isConnected)this.opener.focus();});
    this.searchDialog.addEventListener('click',e=>{if(e.target===this.searchDialog){const r=this.searchDialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.searchDialog.close();}});
    this.input.addEventListener('input',()=>{this.clear.hidden=!this.input.value;clearTimeout(this.timer);this.controller?.abort();this.sequence=(this.sequence||0)+1;this.timer=setTimeout(()=>this.search(),250);});
    this.querySelector('.md-search-form').addEventListener('submit',()=>{this.input.value=this.normalize(this.input.value.trim());});
    this.querySelector('.md-search-form').addEventListener('reset',()=>{clearTimeout(this.timer);this.controller?.abort();this.sequence=(this.sequence||0)+1;this.input.value='';this.results.replaceChildren();this.collectionLinks.replaceChildren();this.related.hidden=true;this.ideas.hidden=false;this.clear.hidden=true;this.status.textContent='';this.all.hidden=true;this.input.focus();});
  }
  disconnectedCallback(){document.removeEventListener('click',this.onClick);clearTimeout(this.timer);this.controller?.abort();this.ready=false;}
  normalize(q){const aliases={'sitz':'Sitzbank','sattel':'Sitzbank','endtopf':'Auspuff','endtoepfe':'Auspuff','endtöpfe':'Auspuff','exhaust':'Auspuff','handlebar':'Lenker'};return aliases[q.toLowerCase()]||q;}
  async search(){this.clear.hidden=!this.input.value;this.controller?.abort();const seq=this.sequence=(this.sequence||0)+1;const q=this.input.value.trim();const searchTerm=this.normalize(q);this.results.replaceChildren();this.collectionLinks.replaceChildren();this.related.hidden=true;this.all.hidden=q.length<2;this.ideas.hidden=q.length>=2;const root=this.dataset.root.endsWith('/')?this.dataset.root:this.dataset.root+'/';this.all.href=root+'search?type=product&q='+encodeURIComponent(searchTerm);if(q.length<2){this.status.textContent='';return;}this.controller=new AbortController();this.status.textContent=this.dataset.loading;try{const params=new URLSearchParams({q:searchTerm,'resources[type]':'product,collection','resources[limit]':'6','resources[limit_scope]':'each','resources[options][unavailable_products]':'last'});const response=await fetch(root+'search/suggest.json?'+params,{signal:this.controller.signal});if(!response.ok)throw Error();const data=await response.json();if(seq!==this.sequence)return;const collections=data.resources?.results?.collections||[];for(const collection of collections.slice(0,4)){const url=new URL(collection.url,location.origin);if(url.origin!==location.origin)continue;const a=document.createElement('a');a.href=url.href;a.textContent=collection.title+' →';this.collectionLinks.append(a);}this.related.hidden=!this.collectionLinks.children.length;const products=data.resources?.results?.products||[];this.status.textContent=products.length?(searchTerm!==q?this.dataset.searchAs.replace('[term]',searchTerm):''):this.dataset.empty;const formatter=new Intl.NumberFormat(document.documentElement.lang||'de',{style:'currency',currency:this.dataset.currency||'EUR'});for(const product of products){const link=document.createElement('a');link.className='md-product';const url=new URL(product.url,location.origin);if(url.origin!==location.origin)continue;link.href=url.href;if(product.image){const img=document.createElement('img');img.src=product.image;img.alt='';img.width=220;img.height=150;img.loading='lazy';link.append(img);}const name=document.createElement('strong');name.textContent=product.title;const price=document.createElement('span');price.textContent=formatter.format(Number(product.price));link.append(name,price);if(!product.available){const stock=document.createElement('span');stock.textContent=this.dataset.sold;link.append(stock);}this.results.append(link);}}catch(e){if(e.name!=='AbortError'&&seq===this.sequence)this.status.textContent=this.dataset.error;}}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["medusa-home-highlights"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const tabs = [...root.querySelectorAll('[data-mh-tab]')];
    const panels = [...root.querySelectorAll('[data-mh-panel]')];
    const select = (key) => {
      tabs.forEach(tab => {const active = tab.dataset.mhTab === key;tab.setAttribute('aria-selected', String(active));tab.tabIndex = active ? 0 : -1;});
      panels.forEach(panel => {panel.hidden = panel.dataset.mhPanel !== key;});
      root.querySelectorAll('.mh-track').forEach(track => track.dispatchEvent(new Event('scroll')));
    };
    root.classList.add('mh-ready');
    root.querySelector('.mh-tabs').hidden = false;
    panels.forEach(panel => {panel.setAttribute('role','tabpanel');panel.setAttribute('aria-labelledby',root.querySelector(`[data-mh-tab="${panel.dataset.mhPanel}"]`).id);});
    tabs.forEach((tab,index) => {
      tab.addEventListener('click',() => select(tab.dataset.mhTab));
      tab.addEventListener('keydown',event => {
        let next = index;
        if(event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        else if(event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
        else if(event.key === 'Home') next = 0;
        else if(event.key === 'End') next = tabs.length - 1;
        else return;
        event.preventDefault();select(tabs[next].dataset.mhTab);tabs[next].focus();
      });
    });
    panels.forEach(panel => {
      const track = panel.querySelector('.mh-track');
      const prev = panel.querySelector('[data-mh-prev]');
      const next = panel.querySelector('[data-mh-next]');
      panel.querySelector('.mh-arrows').hidden = false;
      const update = () => {prev.disabled = track.scrollLeft <= 2;next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;};
      const move = direction => track.scrollBy({left:direction * track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      prev.addEventListener('click',() => move(-1));next.addEventListener('click',() => move(1));track.addEventListener('scroll',update,{passive:true});new ResizeObserver(update).observe(track);update();
    });
    select('new');
  }
  document.querySelectorAll('[data-medusa-highlights]').forEach(init);
  document.addEventListener('shopify:section:load',event => event.target.querySelectorAll('[data-medusa-highlights]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();
})();
